import React, { forwardRef } from 'react';
import { getAllCountries } from '../../../helpers/country';

const countries = getAllCountries();

export const CountrySelectInputField = forwardRef(
  (
    {
      label = 'Country',
      error,
      extraClasses = '',
      options = countries,
      placeholder = 'Select country',
      RenderOption = ({ item }) => (
        <option value={item?.isoCode}> {item?.name}</option>
      ),
      height = '36',
      disabled = false,
      ...rest
    },
    ref,
  ) => {
    const text = error || label || '';
    return (
      <div className="w--full d--flex flex--column">
        {text && (
          <label
            className={`label--control font--sm font--500 m-b--sm ${
              error ? 'text--danger' : 'text--black'
            }`}
          >
            {text}
          </label>
        )}
        <select
          ref={ref}
          {...rest}
          className={`form--control w--full h-min--${height} radius--sm p-l--sm p-r--sm ${extraClasses} ${
            error ? 'border-full--danger' : 'border-full--black-200'
          }`}
          disabled={disabled}
        >
          {placeholder && <option value="">{placeholder}</option>}
          {options?.map((item, index) => (
            <RenderOption key={index} item={item} />
          ))}
        </select>
      </div>
    );
  },
);
